"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncLocalStorage = void 0;
var _nodeAsync_hooks = require("node:async_hooks");
/**
 * Instance of AsyncLocalStorage for usage with LoggerMetadata.
 */
const asyncLocalStorage = exports.asyncLocalStorage = new _nodeAsync_hooks.AsyncLocalStorage();
